import assign from 'lodash/assign.js';
import initialState from './state.js';

export default {
    resetState(state) {
        Object.assign(state, initialState);
    },

    // AUTOMATIONS
    setAutomations(state, automations) {
        state.automations = automations;
    },
    setSelectedAutomation(state, automation) {
        state.selectedAutomation = automation;
    },
    setSelectedAutomations(state, automations) {
        state.selectedAutomations = automations;
    },
    addAutomation(state, automation) {
        state.automations.push(automation);
    },
    updateAutomation(state, automation) {
        if (empty(automation.id)) {
            return;
        }

        // Find automation
        let tmpAutomation = state.automations.find(value => value.id == automation.id);

        if (empty(tmpAutomation)) {
            return;
        }

        tmpAutomation = assign(tmpAutomation, automation);
    },
    deleteAutomation(state, automation) {
        state.automations.splice(state.automations.indexOf(automation), 1);
    },
};
